export default (code) => {
  var color = "blue"
  if (code <= 35) {
    color = "orange"
  } else if (code <= 66) {
    color = "teal"
  } else if (code <= 71) {
    color = "pink darken-3"
  } else if (code <= 76) {
    color = "purple"
  } else if (code <= 86) {
    color = "yellow darken-3"
  } else if (code <= 96) {
    color = "red"
  } else if (code <= 104) {
    color = "blue-grey"
  } else if (code <= 116) {
    color = "blue"
  }
  return color;
}